'use client'

import Event from '@/utils/event'
import { isDirectUserGesture } from '@/utils/direct-user-gesture'
import { isIosTextEntry } from '@/utils/ios-text-entry'

export const PASSWORD_MODAL_INPUT_ID = 'password-modal-input'

// password.tsx owns the in-memory unlock flag. Default to locked until that
// module evaluates — a password cannot be cached before it loads.
let isLocked = () => true

export function bindPasswordLock(check: () => boolean) {
	isLocked = check
}

export function focusPasswordInput(input: HTMLInputElement): boolean {
	input.focus({ preventScroll: true })
	if (typeof document !== 'undefined' && document.activeElement === input) {
		input.dataset.keyboardArmed = 'true'
		return true
	}
	return false
}

export function focusMountedPasswordInput(): boolean {
	if (typeof document === 'undefined') return false
	const input = document.getElementById(PASSWORD_MODAL_INPUT_ID)
	if (!(input instanceof HTMLInputElement)) return false
	return focusPasswordInput(input)
}

// Ask the unlock modal to mount and focus its field while the tap is still
// on the stack. No-op on desktop and after the handler has awaited.
export function openPasswordModalForGesture(): void {
	if (typeof window === 'undefined') return
	if (!isIosTextEntry() || !isDirectUserGesture() || !isLocked()) return
	Event.emit('open-password-modal')
}
